import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Switch
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const ResendWelcomeEmailDialog = ({ open, onClose, onConfirm, customer, loading }) => {
  const { t } = useTranslation();
  const [resetPassword, setResetPassword] = useState(false);

  // Reset the toggle each time the dialog is opened for a customer
  useEffect(() => {
    if (open) {
      setResetPassword(false);
    }
  }, [open]);

  const handleConfirm = () => {
    onConfirm({ resetPassword });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {t('customers.resendWelcome.title')}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ color: 'text.primary', fontSize: '1rem', mb: 2 }}>
          {t('customers.resendWelcome.confirmation', {
            name: customer?.fullName || customer?.email
          })}
        </DialogContentText>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          {t('customers.resendWelcome.info')}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={resetPassword}
              onChange={(e) => setResetPassword(e.target.checked)}
              color="warning"
            />
          }
          label={t('customers.resendWelcome.sendNewPasswordLabel')}
        />
        {resetPassword && (
          <Typography variant="caption" sx={{ display: 'block', color: 'warning.main', mt: 1 }}>
            {t('customers.resendWelcome.sendNewPasswordHint')}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          size="large"
          disabled={loading}
          sx={{ textTransform: 'none' }}
        >
          {t('common.cancel')}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          size="large"
          disabled={loading}
          sx={{ textTransform: 'none', minWidth: 100 }}
        >
          {t('customers.resendWelcome.sendButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResendWelcomeEmailDialog;
